import { render } from "./ChooseLoginOrSignup.vue?vue&type=template&id=b9a2b9f8"
import script from "./ChooseLoginOrSignup.vue?vue&type=script&lang=js"
export * from "./ChooseLoginOrSignup.vue?vue&type=script&lang=js"

import exportComponent from "/builds/nordhealth/projects/therapy/easypractice/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__